'use client';

import { useEffect, useState, useCallback } from 'react';

import Router from 'next/router';

export const usePageTransitionAnimation = (
  shouldShowAnimationOnTransitionTo: (destinationURL: string) => boolean = () =>
    true
) => {
  const [loadingState, setLoadingState] = useState(false);
  const showLoading = useCallback(() => setLoadingState(true), []);
  const hideLoading = useCallback(() => setLoadingState(false), []);

  useEffect(() => {
    Router.events?.on('routeChangeStart', (destinationURL: string) => {
      if (shouldShowAnimationOnTransitionTo(destinationURL)) {
        showLoading();
      }
    });
    Router.events?.on('routeChangeComplete', hideLoading);

    return () => {
      Router.events?.off('routeChangeStart', showLoading);
      Router.events?.off('routeChangeComplete', hideLoading);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Router, showLoading, hideLoading]);
  return { isLoading: loadingState, hideLoading, showLoading };
};
